import React, { PropTypes } from 'react';
import EntityImage from '../EntityImage';

const EntityChild = ({ node, entityUrl, orderer, onDelete }) => (
  <tr>
    <td className="two wide">
      <a
        href={entityUrl(node)}
        className="ui labeled icon button"
        target="_blank"
      >
        <i className="right arrow icon" /> Voir
      </a>
    </td>
    <td className="seven wide">
      <h3 className="ui image header">
        <EntityImage entity={node} />
        <div className="content contentTitle">{node.title}</div>
      </h3>
    </td>
    <td className="two wide">
      {node.obsolete && <div className="ui red horizontal label">Obsolète</div>}
    </td>
    <td className="two wide">{orderer}</td>
    <td className="three wide center aligned">
      <div className="ui tiny buttons">
        <button className="ui red icon button" onClick={onDelete}>
          <i className="remove icon" />Supprimer
        </button>
      </div>
    </td>
  </tr>
);

EntityChild.propTypes = {
  node: PropTypes.object.isRequired,
  entityUrl: PropTypes.func.isRequired,
  orderer: PropTypes.element.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default EntityChild;



// WEBPACK FOOTER //
// ./src/modules/catalog/components/child/EntityChild.js